module.exports = __webpack_public_path__ + "img/downtime-unplanned.b81235cb.svg";